import React from 'react'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'
import { IGatedContentMvp as IContentfulGatedContent } from 'marketing-site/@types/generated/contentful'
import { transformCTAWithBackground } from 'marketing-site/src/transformers/elements/ContentfulCTALink'
import { camelCase } from 'lodash'
import {
  GatedContent,
  IProps as IGatedContent,
} from 'marketing-site/src/mvp/library/components/GatedContent'

export const ContentfulGatedContent = (
  gatedContent: IContentfulGatedContent,
): React.ReactElement => (
  <EntryMarker entry={gatedContent}>
    {() => <GatedContent {...transformGatedContent(gatedContent)} />}
  </EntryMarker>
)

export function transformGatedContent({ fields }: IContentfulGatedContent): IGatedContent {
  return {
    ...fields,
    eyebrow: fields.eyebrow && fields.eyebrow,
    title: fields.title,
    subhead: fields.subhead && fields.subhead,
    image: fields.image && fields.image,
    cta: fields.cta && transformCTAWithBackground(fields.cta),
    layout: fields.layout,
    backgroundColor:
      fields.backgroundColor &&
      (camelCase(fields.backgroundColor) as IGatedContent['backgroundColor']),
  }
}
